import useAuth from 'auth/hook/useAuth';
import { createContext, useEffect, useState } from 'react';

export const PRICE_LIST = {
  '3m': 750,
  '6m': 990,
  '1y': 1790,
  '15m': 2475,
};

export const PKG_OPTIONS = [
  { value: '3m', label: '3 เดือน' },
  { value: '6m', label: '6 เดือน' },
  { value: '1y', label: '1 ปี' },
  { value: '15m', label: '15 เดือน' },
];

const PkgContext = createContext({ options: PKG_OPTIONS, priceList: PRICE_LIST });

export const PkgProvider = ({ children }) => {
  const { auth } = useAuth();

  const [options, setOptions] = useState(PKG_OPTIONS);
  const [discount, setDiscount] = useState(PRICE_LIST);
  const [priceList] = useState(PRICE_LIST);
  const [credit, setCredit] = useState(0);

  useEffect(() => {
    if (auth?.discount) {
      // const price = auth?.discount;
      setOptions([
        { value: '3m', label: '3 เดือน' },
        { value: '6m', label: '6 เดือน' },
        { value: '1y', label: '1 ปี' },
        { value: '15m', label: '15 เดือน' },
      ]);
      setDiscount(auth.discount);
    }
    if (auth?.credit >= 0) {
      setCredit(auth?.credit);
    }
  }, [auth?.discount, auth?.accessToken, auth?.credit]);

  return <PkgContext.Provider value={{ options, discount, credit, priceList }}>{children}</PkgContext.Provider>;
};

export default PkgContext;
